import { NativeStackHeaderProps } from '@react-navigation/native-stack';
import { useGoBack } from '../../../utils/appNavigationNames';

export type UseSafeGoBackArgs = NativeStackHeaderProps;

export type UseSafeGoBackReturnValue = {
    goBack: () => void;
};

export const useSafeGoBack = ({ navigation }: UseSafeGoBackArgs): UseSafeGoBackReturnValue => {
    const fallbackGoBack = useGoBack();
    const canGoBack = navigation.canGoBack();
    return canGoBack ? { goBack: navigation.goBack } : { goBack: fallbackGoBack };
};
